import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class DatetimeService {
    constructor(
        private httpClient: HttpClient,
        private authService: AuthenticationService
    ) { }

    private get base() {
        return `${this.authService.baseUrl}/util`;
    }

    public getDateTime(): Observable<ApiResponse<string>> {
        return this.httpClient.get<ApiResponse<string>>(`${this.base}/GetDateTime`);
    }

    public async obterDataHora(): Promise<Date> {
        const res = await firstValueFrom(
            this.getDateTime()
        );

        return res.data as any;
    }
}
